import { Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { WidgetTemplateSetting } from '../../../models/widget';

export interface WidgetSettingAble {
  change(): EventEmitter<any>;

  setValue(value: any);

  init(setting: WidgetTemplateSetting);
}

@Component({
  selector: 'cw-widget-setting',
  templateUrl: './widget-setting.component.html',
  styleUrls: ['./widget-setting.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WidgetSettingComponent),
      multi: true,
    }]
})
export class WidgetSettingComponent implements OnInit, OnChanges {
  @Input() form: FormGroup;
  @Input() setting: WidgetTemplateSetting;

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/edit-widget-modal/widget-setting/widget-setting.component.ts